import { render, staticRenderFns } from "./page-header_jhk.vue?vue&type=template&id=f18bcd4a&scoped=true"
import script from "./page-header_jhk.vue?vue&type=script&lang=js"
export * from "./page-header_jhk.vue?vue&type=script&lang=js"
import style0 from "./page-header_jhk.vue?vue&type=style&index=0&id=f18bcd4a&prod&lang=scss&scoped=true"
import style1 from "./page-header_jhk.vue?vue&type=style&index=1&id=f18bcd4a&prod&lang=scss"
import style2 from "./page-header_jhk.vue?vue&type=style&index=2&id=f18bcd4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18bcd4a",
  null
  
)

export default component.exports